<template>
  <div class="p_supply_module p_fee_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">归属月份</div>
                    <el-date-picker v-model="listQuery.belongMonth" :clearable="false" size="small" value-format="yyyy-MM" type="month" placeholder=""></el-date-picker>
                </div>
                <div class="screenInput">
                  <div class="flname">施工队名称</div>
                  <el-input v-model="listQuery.strConstrteamName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-if="checkPermission(['supFeeList_page_list'],permissionLists)">
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" v-if="checkPermission(['supFeeList_import'],permissionLists)">
              <el-button size="small" type="primary" @click="importHandle">导入</el-button>
            </div>
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['supFeeList_export'],permissionLists))">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" border v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <!-- <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
              <template slot-scope="{$index}">
                  <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                </template>
            </el-table-column> -->
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('类型')>-1||item.StrColumName.indexOf('籍贯')>-1 ? '80px' : item.StrColumName.indexOf('初始数量')>-1||item.StrColumName.indexOf('服务商数量')>-1||item.StrColumName.indexOf('含税')>-1||item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('%')>-1?'160px':'110px'" align="center"
                :fixed="item.StrColumName=='施工队编码'||item.StrColumName=='施工队名称'">
                <template slot-scope="{row}">
                  <span>{{row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 费用单导入弹框 -->
    <el-dialog title="费用单导入" :visible.sync="importVisible" width="700px" class="res_dialog">
      <div class="p_demand_plan">
        <el-steps :active="curractive" finish-status="success" class="steps-box">
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <div v-if="curractive==0" style="margin-top:15px;padding-bottom:15px;">
          <div class="flex">
            <div>
              <div>归属月份:</div>
              <div class="storageArea">
                  <el-date-picker v-model="belongDate" size="small" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
                <!-- <div class="storageInput" style="margin:0 20px 0 0">
                  <el-select v-model="tabName" slot="prepend" placeholder="请选择" disabled filterable @change="selectTab">
                    <el-option v-for="(item, index) in this.tableList" :key="index" :label="item.StrTableName" :value="{value:item.StrTableId,label:item.StrTableName}"></el-option>
                  </el-select>
                </div> -->
              </div>
            </div>
            <div style="margin-left:150px">
              <div>导入模板下载:</div>
              <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;margin-top:10px">下载模板</el-button>
            </div>
          </div>
        </div>
        <div v-if="curractive==1" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p style="font-weight:bold;">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。</p>
            <p>2. 请将要上传的内容放在第一个sheet中。</p>
            <p>3. 请不要加密模板文件，将导致错误。</p>
            <p>4. 请不要上传带宏的文件，将导致错误。</p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
            <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
          </div>
          <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <!-- 提示 -->
          <p style="color:red;" v-if="isError">{{errorTxt}}</p>
        </div>
        <div v-if="curractive==2" style="margin-top:15px;padding-bottom:15px;">
          <div class="result-box">
            <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
          </div>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importVisible = false" v-if="curractive==0">取消</el-button>
        <el-button size="small" @click="prevSteps" v-if="curractive>0 && curractive<=1">上一步</el-button>
        <el-button type="primary" class="com_dialog_btn" size="small" @click="nextSteps" v-if="curractive<1&&isimp==0">下一步</el-button>
        <el-popconfirm style="margin-left:15px" confirm-button-text='删除旧数据重新导入' cancel-button-text='不删除旧数据' icon="el-icon-info" icon-color="red" v-if="curractive<1 && (isimp!=0)" title="该月份已经导入过数据，请问是否删除之前导入的数据重新导入？" @confirm="nextDlt" @cancel="cancelDltSteps">
            <el-button v-loading.fullscreen.lock="isDltFinnish" element-loading-text="此操作可能耗费较长时间，请稍后..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" slot="reference" type="primary" size="small">下一步</el-button>
          </el-popconfirm>
        <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请稍后..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-show="curractive==1" :disabled="isUploadSuccess">提交</el-button>
        <el-button type="primary" size="small" @click="backHandle" v-if="curractive==2">确认并返回</el-button>
        <el-button size="small" @click="resultHandle" v-if="curractive==2">查看导入结果</el-button>
    </span>
    </el-dialog>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  // import SupComTabs from "../supplierManage/components/supComTabs.vue"
  export default {
    // components: {
    //     SupComTabs
    // },
    data() {
      return {
        //禁用日期范围
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
            }
        },
        isimp:0,//是否导入过
        uploadTempQuery:{
          tableid:'JB_busi_UtilityBill',
          fileid:'费用单导入'
        },
        // 导入归属月份
        belongDate:'',
        // 导入显示页面
        curractive: 0,
        importDialog:false,
        importVisible:false,
        typeName:'费用单',
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'费用单列表',
        activeName:'third',
        tableData: [],
        listQuery:{
          strConstrteamName:'',//施工队名称
          strBusitype:'',//业务类型
          strCity:'',// 城市
          belongMonth:'',// 归属月
          currpage:1,
          perpage:10
        },
        exportQuery:{},
        btnLoading:false,
        downVisible:false,
        custPath: '',//导出文件下载路径
        // 表头参数
        titleQuery:{
          strTableId:'JB_busi_UtilityBill', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        tablePath: this.$store.state.EMP.tablePath,
        ExcelSrc: {
            value: '',
            check: false,
            fileName: ''
        },
        excelpath: '',
        entid: '',
        reimp: 0,//是否覆盖导入
        isUploadSuccess: false,
        fullscreenLoading: false,
        errorTxt: '',
        //是否下载过导入模板
        isDownFeeTemplate: false,
        //表头错误提示
        isError: false,
        StrUserName:'',
        StrObjName:'',
        //角色类型
        roleType: '',
        // 按钮权限参数
        butQuery:{
          path:'/supFeeList',
          powerEnName:'supplierManage'
        },
        permissionLists:[],
        isDltFinnish:false//是否已经走完删除接口
      }
    },
    created() {
      this.calHeight();
      this.roleType = localStorage.loginRoletype
      if (window.localStorage.getItem('isDownFeeTemplate')) {
        this.calDaysBetween(window.localStorage.getItem('isDownFeeTemplate'))
      }
      let lastDate = moment().subtract(1,'months').format("YYYY-MM")
      this.listQuery.belongMonth = lastDate
      this.getButtonPower()//按钮权限
    },
    methods: {
      checkPermission,
        // 获取按钮权限
        getButtonPower(){
          let that = this
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(that.checkPermission(['supFeeList_page_list'],that.permissionLists)){
                  // 表头
                  that.getTableTitleLists()
                }
              }else{
                this.permissionLists = []
              }
            }else{
              this.permissionLists = []
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        //导入-确认返回
        backHandle() {
            this.importVisible = false
            // location.reload();
            this.getList();
        },
        // 导入弹框
        importHandle(){
            this.importVisible = true
            this.curractive = 0
            this.errorTxt = ''
            this.belongDate = ''
            this.ExcelSrc = {
                value: '',
                check: false,
                fileName: ''
            }
        },
        //查看导入结果
        resultHandle() {
            this.importVisible = false
            this.$router.push({
                path: "/supplyLog",
                query:{
                active:'导入记录'
                }
            })
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,this.titleQuery.strTableId).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 删除
        nextDlt(){
          // this.fullscreenLoading = true
          this.isDltFinnish = true
          xz.delUtilityBill({belongMonth: this.belongDate}).then(res => {
            // console.log('resetMember', res)
            if (res.status == 'ok') {
              this.$message({ type: 'success', message: '删除成功' })
              this.nextSteps();
              // this.fullscreenLoading = false;
            }else{
              this.$message({ type: 'error', message: res.msg })
            }
            this.isDltFinnish = false
          });
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            // console.log('33',res)
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getUtilityBillLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.tableData = res.msg
                  this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        selectMonth(val){
          this.listQuery.belongMonth = this.belongDate
          //判断社保是否已经导入过
          xz.getUtilityBillLists(this.listQuery).then(res => {
            if (res.status == 'ok') {
              this.isimp = Number(res.totalcount);
              // console.log('ds', res.totalnum)
            }
          })
        },
        // 取消删除
        cancelDltSteps(){
          this.curractive = 0
        },
        //上一步导入
        prevSteps() {
            this.curractive -= 1
        },
        //下一步导入
        nextSteps() {
            // if (this.active++ > 2) this.active = 0;
            if (this.curractive == 0) {
                // if (this.tabName == '') {
                //     this.$message({
                //         message: "请选择导入模板",
                //         type: "warning"
                //     });
                //     this.curractive = 0
                // return false
                // }
                if (this.isNull(this.belongDate)) {
                    this.$message.warning('请选择归属月份')
                    return false
                }
                // if (!this.isDownFeeTemplate) {
                //     this.$message({
                //         message: "请先下载导入模板，下一步导入请使用新的模板导入",
                //         type: "warning",
                //         duration: 5000
                //     });
                //     return false
                // }
            }
            this.curractive += 1
        },
        //提交导入
        async lastSteps() {
          let that = this
            if (this.ExcelSrc.value == '') {
                this.isUploadSuccess = true
                this.$message({
                message: "请选择文件上传",
                type: "warning"
                });
                this.curractive = 0
                return false
            }else {
                //检查表头是否正确
                let checkData = {
                    excelpath: this.excelpath,
                    tableid: "JB_busi_UtilityBill",
                    fileid: '费用单导入'
                }
                // console.log('checkData', checkData)
                this.fullscreenLoading = true;
                xz.chkcrmTableForm(checkData).then(res => {
                // console.log('checkData',res)
                // //第一个冒号出现的位置
                // let firstIndex = res.indexOf(":")
                // //根据第一个点的位置 获得第二个点的位置
                // let secondIndex = res.indexOf(":", firstIndex + 1)
                // //根据第二个点的位置，截取 字符串。
                // let resultTxt = res.slice(Number(secondIndex + 2), -2)
                let resultTxt = res.msg
                // console.log('resultTxt',this.isNull(res))
                if (this.isNull(res.msg)) {
                    this.isError = false
                    this.isUploadSuccess = false
                    const Edata = {
                      tableid: "JB_busi_UtilityBill",
                      excelpath: that.excelpath,
                      impexcel: that.ExcelSrc.fileName,
                      belongMonth: that.belongDate,
                      fileid: '费用单导入'
                    }
                    xz.anlycrmsisExcelInf(Edata).then(res => {
                        // console.log('Edata', res)
                        if (res.status == 'ok') {
                            this.curractive = 2
                        } else {
                            this.$message('导入错误');
                        }
                        this.fullscreenLoading = false;
                        // this.isUploadSuccess = true
                    })
                } else {
                    this.isError = true
                    this.curractive = 1
                    this.isUploadSuccess = true
                    this.errorTxt = resultTxt
                    //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
                    //清空input file值
                    var file = document.getElementById("fileInput");
                    file.value = '';
                    this.fullscreenLoading = false;
                }
                })
            }
        },
        //下载模板
        downLoadHandle() {
            xz.getcrmOutPutMode('JB_busi_UtilityBill','费用单导入').then(res => {
                // console.log('下载模板', res)
                if (res) {
                    this.isDownFeeTemplate = true;
                    window.localStorage.setItem('isDownFeeTemplate', new Date());
                    var d = res.msg.data.StrOutPath
                    d = d.replace("\"", "").replace("\"", "")
                    var path = this.tablePath + d
                    const aTag = document.createElement('a')
                    aTag.href = path
                    aTag.click();
                }
            })
        },
        calDaysBetween(date) {
            let startDate = Date.parse(date);
            let endDate = Date.parse(new Date());
            let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            days > 7 ? this.isDownFeeTemplate = false : this.isDownFeeTemplate = true;
        },
        //文件读取
        async importf() {
            const fileInput = this.$refs.upload;
            this.excelpath = ''
            FUN.returnExcelSrc(fileInput).then(src => {
                if (src) {
                // console.log('src0o0', src)
                this.isUploadSuccess = true
                this.$set(this.ExcelSrc, "value", src.src);
                this.$set(this.ExcelSrc, "check", false);
                this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
                // console.log('srccc', this.ExcelSrc)
                //上传excel
                const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
                const formData = new FormData();
                formData.append("pagename", 'empexcel');
                formData.append("action", 'save');
                formData.append("userid", Cookies.get("userid-b"));
                formData.append("entid", Cookies.get("userid-b"));
                formData.append("excel", excelFile, this.ExcelSrc.fileName);
                // console.log('formData', formData)
                xz.uploadCert(formData).then(res => {
                    // console.log('formData', res)
                    if (this.isNull(res) || res == false) {
                        this.$message('上传Excel失败!')
                        this.isUploadSuccess = true
                    } else {
                        this.errorTxt = ''
                        this.excelpath = res;
                        this.isUploadSuccess = false
                    }
                });
                } else {
                    this.$message('上传Excel失败!')
                }
            })
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
          this.listQuery = this.$options.data.call(this).listQuery
          let lastDate = moment().subtract(1,'months').format("YYYY-MM")
          this.listQuery.belongMonth = lastDate
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>